// Types mirroring apps/api/app/schemas.py response shapes actually consumed
// by the Portal. Keep field names/casing identical to the backend — these
// are not DTOs to transform, they're the wire shape.

export type Zone = "A" | "B" | "C" | "D" | "E" | "F";

export const PROXIMITY_BANDS = ["FRÍO", "ACERCÁNDOTE", "CERCA", "MUY CERCA"] as const;
export type ProximityBand = (typeof PROXIMITY_BANDS)[number];

// GET /api/v1/targets/{targetId}/carrier
export interface CarrierPosition {
  carrierId: string;
  zoneId: string;
  latitude: number | null;
  longitude: number | null;
  accuracyMeters: number | null;
  reportedAt: string;
}

export interface CarrierReadModel {
  currentPosition: CarrierPosition | null;
  movementHistory: CarrierPosition[];
}

// GET /api/v1/hunters
export interface ClosestParticipant {
  participantId: string;
  rssi: number;
  previousRssi: number | null;
  band: string;
  lastSeen: string;
}

export interface HuntersReadModel {
  // connectedParticipants: phones with a recent bootstrap/heartbeat — "app
  // alive", independent of BLE. trackingParticipants: subset of those with
  // a recent target detection — "has signal on the target".
  connectedParticipants: number;
  trackingParticipants: number;
  // Deprecated alias of trackingParticipants (old meaning of this field,
  // kept for anything that still reads it).
  activeParticipants: number;
  detectionsPerMinute: number;
  bands: Record<string, number>;
  closestParticipants: ClosestParticipant[];
}

// GET /api/v1/round/current
export interface RoundCurrentTarget {
  targetId: string;
  displayName: string | null;
  displayAlias: string | null;
  positionSource: "CARRIER" | "GATEWAY_FUSION";
  carrierId: string | null;
}

export interface RoundCurrent {
  roundId: string | null;
  status: "LIVE" | "NO_ACTIVE_ROUND";
  targets: RoundCurrentTarget[];
}

// GET /api/v1/metrics
export interface PortalMetrics {
  activeFixedGateways: number;
  activeParticipants: number;
  detectionsTotal: number;
  detectionsLastMinute: number;
  detectionsPerMinute: number;
  targetsActive: number;
  carrierFreshness: number | null;
  participantDetectionRate: number;
}
